import { render, staticRenderFns } from "./ShortMessageTem.vue?vue&type=template&id=00ec8f5e&scoped=true"
import script from "./ShortMessageTem.vue?vue&type=script&lang=js"
export * from "./ShortMessageTem.vue?vue&type=script&lang=js"
import style0 from "./ShortMessageTem.vue?vue&type=style&index=0&id=00ec8f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec8f5e",
  null
  
)

export default component.exports